interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export default function EmptyState({ icon = "ri-inbox-line", title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg bg-background-100 border border-background-200">
      <span className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center text-foreground-400 mb-4">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="text-base font-bold text-foreground-800">{title}</h3>
      {description && <p className="text-sm text-foreground-500 mt-2 max-w-md">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}